import { useNavigate } from 'react-router-dom'

import { AppRoutes } from '@/constants/appRoutes'
import { LocalStorageKey } from '@/constants/localStorageKeys'
import { useLogoutMutation } from '@/store/api/Auth/Auth.query'
import { resetUser } from '@/utils/analytics'
import cookieService from '@/utils/cookies'
import localStorageService from '@/utils/localStorage'

export const useLogout = () => {
  const navigate = useNavigate()
  const [makeLogoutRequest] = useLogoutMutation()
  const logout = async () => {
    localStorageService.remove(LocalStorageKey.token)

    // Remove CloudFront signed cookies
    cookieService.removeCloudFrontCookies()

    // Reset PostHog user identity
    resetUser()

    navigate(AppRoutes.login)
    await makeLogoutRequest()
  }

  return { logout }
}
